import { render } from "./index.vue?vue&type=template&id=b567a4d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b567a4d2&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=b567a4d2&lang=scss"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b567a4d2"]])

export default __exports__